import { SelectOptionType } from "../models/GlobalModels";


export const Constants = {
  APP_NAME: 'Grievances',
};

export const DEFAULT_OPTION: SelectOptionType = { label: "Please Select", value: "" };

export const TABLE_SORT_AESC: string = "AESC";
export const TABLE_SORT_DESC: string = "DESC";


export const LOGIN_STATUS = {
  INITIATED: "initiated",
  AUTHENTICATED: "authenticated",
  NO_AUTHENTICATED: "no-authenticated",
};

export const METHOD = {
  POST: "POST",
  GET: "GET",
  PUT: "PUT",
  PATCH: "PATCH",
};

export const API_STATUS = {
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};
export const API_RESPONSE_CODE = {
  FAIL: "1",
  SUCCESS: "0",
};

export const STORAGE_KEY = {
  AUTH_DATA: "app-auth",
  ITUS: "app-itus",
};

export const SIDE_MENU_STATUS = {
  OPEN: 1,
  CLOSE: 2,
  OPPOSITE: 3,
};

export const LIST_VIEW_ITEM = {
  LIST_ITEMS: "list-items",
  VIEW_ITEM: "view-item",
};

export const CLICK_ACTIONS = {
  VIEW_GRIEVANCE: "view_grievance",
  VIEW_DOCUMENT: "view_document",
  SELECT_CUSTOMER: "select_customer",
  SELECT_CLAIM: "select_claim",
  SELECT_PROPOSAL: "select_proposal",
  SELECT_POLICY: "select_policy",
  SELECT_APPLICATION: "select_application",
  SELECT_RETAIL_APPLICATION: "select_retail_application",
  SELECT_HEALTH_APPLICATION: "select_health_application",
  SELECT_HEALTH_MEMBER: "select_health_member",
  GET_CLAIM_DATA: "get_claim_data",
  NO_ACTION: 'no_action',
  VIEW_PERMISSIONS: "view_permissions",
  SET_PERMISSIONS: "set_permissions",
  VIEW_USER: "view_user",
  MODIFY_USER: "modify_user",
  DELETE_GRIEVANCE: "delete_grievance",
  SELECT_GRIEVANCE: "select_grievance",
  DELETE_ROLE: "delete_role",
  DELETE_USER: "delete_user",
  EDIT_ROLE: "edit_role",
  MODIFY_ROLE: "modify_role",
  VIEW_DETAILS: "view_details"
};

export const STATUS = {
  NEW: 1,
  IN_PROGRESS: 2,
  RESOLVE: 3,
  REOPEN: 4,
  CLOSE: 5
}

export const LINE_OF_BUSINESS = {
  CROP_RETAIL: 1,
  PMFBY: 2,
  FIRE: 3,
  MOTOR: 4,
  HEALTH: 5,
  RWBCIS: 6,
  TO_BE_ASSIGNED: 7
}

export const PRODUCTS = {
  KSHEMA_SUKRITI: 1,
  KSHEMA_PRAKRITI: 2,
  PMFBY: 3,
  RWBCIS: 4,
  KSHEMA_SAMRIDDHI: 5,
  KISAN_SATHI: 7
}

export const PRODUCT_LOB_MAPPING = {
  [LINE_OF_BUSINESS.CROP_RETAIL]: [PRODUCTS.KISAN_SATHI, PRODUCTS.KSHEMA_PRAKRITI, PRODUCTS.KSHEMA_SUKRITI, PRODUCTS.KSHEMA_SAMRIDDHI],
  [LINE_OF_BUSINESS.PMFBY]: [PRODUCTS.PMFBY],
  [LINE_OF_BUSINESS.RWBCIS]: [PRODUCTS.RWBCIS],
};

export const ROLE_ID = {
  GRO: 1,
  AGENT: 2,
  SUPER_ADMIN: 3
}

export const MIN_YEAR_REPORTS = 2012
export const MIN_DATE_REPORTS = '01-01-2012'
export const MIN_DATE_INTIMATION = `2012-01-01`

export const MAX_ATTACHMENT_SIZE = '10MB'
export const MAX_SIZE_BULK_UPLOAD = 10

export const USER_STATUS = {
  Active: 1,
  Inactive: 2
}

export const TYPE_OF_REQUEST_ID = {
  GRIEVANCE: 1,
  QUERY: 2,
  SERVICE_REQUEST: 3,
  CC_REQUEST: 4,
  TO_BE_ASSIGNED: 5
}

export const POLICY_TYPE_ID = 12

const SUPPORT_CONFIG = {
  email: 'customer.support@kshema.co',
  ombudsmanUrl: 'https://www.cioins.co.in/Ombudsman',
};
export const REMARKS_HELPER_TEXT = `
If you require any additional information or assistance, please contact 14447 for PMFBY (Pradhan Mantri Fasal Bima Yojana).
You may also reach us at 1800 572 3013 or email us at 
<a href="mailto:${SUPPORT_CONFIG.email}" target="_blank">
  ${SUPPORT_CONFIG.email}
</a>.
<br/><br/>
In case you are not satisfied with our response, you may escalate your grievance to the Insurance Ombudsman.
For further details, please visit:
<a href="${SUPPORT_CONFIG.ombudsmanUrl}" target="_blank">
  ${SUPPORT_CONFIG.ombudsmanUrl}
</a>.
`;